//Footer
import React from 'react';

class Footer extends React.Component {
  render(){
    return(
      <footer className="bg-light py-5">
          <div className="container"><div className="small text-center text-muted">Copyright © 2020 - ethar el-karsh</div></div>
      </footer>
    )
  }
}
export default Footer
